import React from 'react';
import './roundScoreStyles.css'
/*
props : {
    round: Number, 
    Error : Number, 
    Score: Number
} */
export const RoundScore = (props) =>{
    /* CODE TO DISPLAY "XXX" */
    const getX = (num) => {
        let xs = '';
        let i = 0;
        for (i = 0; i < num; i++) {
            xs = " X " + xs;
            console.log(xs)
        }
        return (
                <p className="error"> {xs}</p>
        )
    }
    return (
        <div className="round-score-container">
            <p> Round : {Number(props.round)+1} </p>
            {getX(props.error)}
            <p> Score : {props.score} </p>
        </div>
    )
}
